import CBSearchTextFieldController from "../controller/CBSearchTextFieldController";

const CBFirstNameSearchFilter = () => {

    return (
        <CBSearchTextFieldController
            idField="firstName"
            formName="firstName"
            label="firstName"
        />
    )
}

export default CBFirstNameSearchFilter;